import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from 'react-places-autocomplete';

import { connect } from 'react-redux';

import {
  Error,
  IconSearch,
  Input,
  InputContainer,
  Item,
  SelectItems
} from './style';

const createMapObjectClass = (addressComponents = {}) => {
  if (!addressComponents?.administrative_area_level_1) {
    addressComponents.administrative_area_level_1 =
      addressComponents?.administrative_area_level_2 || null;
  }
  if (!addressComponents?.route) {
    addressComponents.route = addressComponents?.establishment || null;
  }
  return {
    ...addressComponents,
    administrative_area_level_3:
      addressComponents?.administrative_area_level_3 ||
      addressComponents?.locality ||
      addressComponents?.postal_town ||
      null
  };
};

const GeolocationField = ({
  apiKey,
  error,
  disabled,
  searchPlaceholder,
  onChangeResult,
  value,
  type,
  iconVersion
}) => {
  const [addressState, setState] = useState('');
  const [ready, setReady] = useState(false);
  const [result, setResult] = useState();
  const [latLong, setlatLong] = useState();

  useEffect(() => {
    const script = document.createElement('script');

    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = false;

    document.body.appendChild(script);
    script.onload = () => {
      setReady(true);
    };

    return () => {
      document.body.removeChild(script);
      setReady(false);
    };
  }, [apiKey]);

  const handleChange = address => {
    setState(address);
    address === '' && onChangeResult({ formatted_address: '' });
  };

  const getLatiLong = () => {
    getLatLng(result)
      .then(({ lat, lng }) => {
        setlatLong({
          latitude: lat,
          longitude: lng
        });
        // eslint-disable-next-line no-console
      })
      // eslint-disable-next-line no-console
      .catch(err => console.log('Error getLatLng: ', err));
  };

  useEffect(() => {
    if (result?.address_components?.length) {
      getLatiLong();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result]);

  const checkType = r => {
    switch (type) {
      case GeolocationField.TYPE.DEFAULT:
        return `${r.route || ''} ${r.street_number || ''}`;
      default:
        return r[type] || '';
    }
  };

  useEffect(() => {
    if (result?.address_components?.length && latLong?.latitude) {
      let realResult = {};
      result.address_components.forEach((address, index) => {
        const nameKey = address.types?.length > 0 ? address.types[0] : index;
        let newObj = {
          [nameKey]:
            nameKey === 'administrative_area_level_2'
              ? address.short_name
              : address.long_name
        };
        if (nameKey === 'country') {
          newObj = {
            [nameKey]: address.long_name,
            [`${[nameKey]}_short_name`]: address.short_name
          };
        }
        realResult = {
          ...realResult,
          ...newObj
        };
      });
      realResult = {
        ...realResult,
        ...latLong,
        formatted_address: result.formatted_address
      };
      const state = checkType(realResult);
      setState(state);
      onChangeResult(createMapObjectClass(realResult));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result, latLong]);

  useEffect(() => {
    if (value !== addressState) {
      setState(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleSelect = address => {
    geocodeByAddress(address)
      .then(results => {
        setResult(results[0]);
      })
      // eslint-disable-next-line no-console
      .catch(err => console.log('Error geocodeByAddress: ', err));
  };

  return (
    apiKey &&
    ready && (
      <>
        <PlacesAutocomplete
          value={addressState}
          onChange={handleChange}
          onSelect={handleSelect}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps }) => (
            <div style={{ position: 'relative' }}>
              <InputContainer
                error={error}
                disabled={disabled}
                iconVersion={iconVersion}
              >
                <Input
                  {...getInputProps({
                    placeholder: searchPlaceholder || 'Search Places',
                    className: 'location-search-input',
                    disabled,
                    type: 'text'
                  })}
                />
                {iconVersion && <IconSearch className="icon-search-5" />}
              </InputContainer>
              {error ? (
                <Error>
                  {typeof error === 'string'
                    ? error
                    : 'Error: the field value is not valid'}
                </Error>
              ) : null}
              <SelectItems
                className="autocomplete-dropdown-container"
                isOpen={!!suggestions?.length}
              >
                {suggestions.map((suggestion, index) => {
                  const className = suggestion.active
                    ? 'suggestion-item--active'
                    : 'suggestion-item';
                  return (
                    <Item
                      key={index}
                      {...getSuggestionItemProps(suggestion, { className })}
                    >
                      {suggestion.description}
                    </Item>
                  );
                })}
              </SelectItems>
            </div>
          )}
        </PlacesAutocomplete>
      </>
    )
  );
};

GeolocationField.TYPE = {
  DEFAULT: 'default',
  COUNTRY: 'country'
};

GeolocationField.defaultProps = {
  type: GeolocationField.TYPE.DEFAULT,
  iconVersion: false
};

GeolocationField.propTypes = {
  apiKey: PropTypes.string,
  error: PropTypes.any,
  disabled: PropTypes.bool,
  searchPlaceholder: PropTypes.string,
  onChangeResult: PropTypes.func,
  value: PropTypes.string,
  type: PropTypes.oneOf([
    GeolocationField.TYPE.DEFAULT,
    GeolocationField.TYPE.COUNTRY
  ]),
  iconVersion: PropTypes.bool
};

export default connect(
  state => ({
    apiKey: state?.app?.config.GOOGLE_MAPS_KEY
  }),
  () => {}
)(GeolocationField);
